import request from '@/utils/request';

export function getCateringList(data) {
	return request({
		url: '/home/catering-v2',
		method: 'get',
		params: data
	});
}
